let selectID = 0;
let filterSelectOptions = [];

document.querySelectorAll('label.select').forEach(label => {
    label.htmlFor = 'select-' + selectID;
    const select = label.querySelector('select');
    select.id = 'select-' + selectID;
    label.addEventListener('click', (e) => {
        if (e.target.tagName === 'SELECT') return;
        e.preventDefault()
        select.focus();
        select.showPicker();
    })
})

document.querySelectorAll('select').forEach(select => {
    if (!('filter' in select.dataset)) return;
    const targetSelect = document.querySelector(`select[name="${select.dataset.filter}"]`);
    select.addEventListener('change', () => {
        const filterID = select.value;
        filterSelect(targetSelect, filterID);
    })
    const filterID = select.value;
    filterSelect(targetSelect, filterID);
})

function filterSelect(targetSelect, filterID) {
    if (typeof filterSelectOptions[name] === 'undefined') {
        filterSelectOptions[name] = [];
        targetSelect.querySelectorAll('option').forEach(option => {
            filterSelectOptions[name].push(option);
        })
    }

    targetSelect.innerHTML = '';
    filterSelectOptions[name].forEach(option => {
        if (!('filter' in option.dataset) || +option.dataset.filter === +filterID || filterID === 'all') {
            targetSelect.append(option);
        }
    })
}